import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FleetMockStore } from '../fleet/mock/fleet-mock.store';
import { FleetVehicle, FLEET_STATUS_META } from '../fleet/mock/models/fleet.models';

@Component({
  selector: 'app-manage-vehicles',
  templateUrl: './manage-vehicles.component.html',
  styleUrls: ['./manage-vehicles.component.css'],
})
export class ManageVehiclesComponent implements OnInit, OnDestroy {
  @ViewChild('addVehicleRef') addVehicleRef: any;

  searchText: string = '';
  vehicles: FleetVehicle[] = [];
  filtered: FleetVehicle[] = [];
  openMenuId: string | null = null;

  // Perfil 360 (drawer)
  selectedVehicleId: string | null = null;
  drawerOpen = false;

  readonly statusMeta = FLEET_STATUS_META;

  private sub?: Subscription;

  constructor(
    private router: Router,
    private readonly store: FleetMockStore,
  ) {
    // do nothing
  }

  ngOnInit(): void {
    // Fuente única de verdad: nada de mocks inline. Todo viene del store,
    // por lo que tabla, mapa, analíticas y perfil quedan coherentes.
    this.sub = this.store.fleet$.subscribe((vehicles) => {
      this.vehicles = vehicles;
      this.applyFilter();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  applyFilter(): void {
    const q = this.searchText.trim().toLowerCase();
    if (!q) {
      this.filtered = [...this.vehicles];
      return;
    }
    this.filtered = this.vehicles.filter((v) => {
      const name = `${v.brand ?? ''} ${v.vehicle_model ?? ''}`.toLowerCase();
      const plate = (v.plate ?? '').toLowerCase();
      return name.includes(q) || plate.includes(q);
    });
  }

  toggleMenu(id: string, event: MouseEvent): void {
    event.stopPropagation();
    this.openMenuId = this.openMenuId === id ? null : id;
  }

  closeMenus(): void {
    this.openMenuId = null;
  }

  openAddVehicle(): void {
    if (this.addVehicleRef && typeof this.addVehicleRef.open === 'function') {
      this.addVehicleRef.open();
    }
  }

  goToCommandCenter(): void {
    this.router.navigate(['/fleet/command-center']);
  }

  onDetails(vehicle: FleetVehicle): void {
    this.closeMenus();
    if (!vehicle || !vehicle.id) return;
    // Abre el perfil 360 en un drawer lateral (no navegación a página larga).
    this.selectedVehicleId = vehicle.id;
    this.drawerOpen = true;
  }

  closeDrawer(): void {
    this.drawerOpen = false;
  }

  onTelemetry(vehicle: FleetVehicle): void {
    this.closeMenus();
    if (!vehicle || !vehicle.id) return;
    this.router.navigate([`/manage-vehicles/${vehicle.id}/analytics`]);
  }

  async onDelete(vehicle: FleetVehicle): Promise<void> {
    this.closeMenus();
    if (!vehicle || !vehicle.id) return;
    this.store.remove(vehicle.id);
  }
}
